import { render, staticRenderFns } from "./STErrorBox.vue?vue&type=template&id=012efc43"
import script from "./STErrorBox.vue?vue&type=script&lang=ts"
export * from "./STErrorBox.vue?vue&type=script&lang=ts"
import style0 from "./STErrorBox.vue?vue&type=style&index=0&id=012efc43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports